<template>
	<div>
		<div class="container">
			<h1 class="mb-2">Film Permits</h1>
		</div>
		<LoginForm />
	</div>
</template>

<script>
import LoginForm from "@/components/LoginForm";

export default {
	name: "login",
	components: {
		LoginForm
	}
};
</script>